module.exports = __webpack_public_path__ + "img/jazzc.f10030f5.jpg";